import {
  CREATE_SPECIFIC_DONATION_MUTATION,
  UPDATE_SPECIFIC_DONATION_MUTATION,
} from '../constants/graphql/specific-donations';
import { TESTATOR_QUERY } from '../constants/graphql/testators';

export const specificDonationMixin = {
  methods: {
    createSpecificDonation(specificDonationInputDetails) {
      this.$apollo
        .mutate({
          mutation: CREATE_SPECIFIC_DONATION_MUTATION,
          variables: {
            specificDonationInputDetails,
          },
          update: (cache, { data: { createSpecificDonation } }) => {
            this.updateDonationsQueryAfterCreate(cache, createSpecificDonation);
            if (createSpecificDonation.donationType == 'ASSET') {
              this.updateAssetsQueryAfterCreate(cache, createSpecificDonation);
            }
          },
        })
        .then(_res => {
          if (
            _res.data.createSpecificDonation.donationOrigin ===
            'RemainderOfEstateBequest'
          ) {
            this.$router.push('/specific-bequests-remainder-of-estate');
          } else {
            this.$router.push('/specific-donations');
          }
        })
        .catch(error => {
          this.displayError();
          throw error;
        });
    },
    updateDonationsQueryAfterCreate(cache, createSpecificDonation) {
      const testatorId = this.testatorId;

      try {
        const query = {
          query: TESTATOR_QUERY,
          variables: { id: testatorId },
        };
        const data = cache.readQuery(query);

        data.testator.specificDonations.push(createSpecificDonation);

        cache.writeQuery({ ...query, data: data });
      } catch (err) {
        if (err.name == 'Invariant Violation') {
          console.log('TESTATOR_QUERY not in cache store yet.');
        } else {
          throw err;
        }
      }
    },
    updateAssetsQueryAfterCreate(cache, createSpecificDonation) {
      const testatorId = this.testatorId;

      const query = {
        query: TESTATOR_QUERY,
        variables: { id: testatorId },
      };
      const data = cache.readQuery(query);

      const assetPropertyName =
        this.$options.assetPropertyNames[createSpecificDonation.assetType];
      var asset = data.testator[assetPropertyName].find(
        a => a.id == createSpecificDonation.assetId
      );
      asset.specificDonation = createSpecificDonation;

      cache.writeQuery({ ...query, data: data });
    },
    updateSpecificDonation(specificDonationInputDetails) {
      const id = this.specificDonation.id;

      this.$apollo
        .mutate({
          mutation: UPDATE_SPECIFIC_DONATION_MUTATION,
          variables: {
            id,
            specificDonationInputDetails,
          },
          update: (cache, { data: { updateSpecificDonation } }) => {
            this.updateDonationsQueryAfterUpdate(cache, updateSpecificDonation);
            if (updateSpecificDonation.donationType == 'ASSET') {
              this.updateAssetsQueryAfterUpdate(cache, updateSpecificDonation);
            }
          },
        })
        .then(_res => {
          if (
            _res.data.updateSpecificDonation.donationOrigin ===
            'RemainderOfEstateBequest'
          ) {
            this.$router.push('/specific-bequests-remainder-of-estate');
          } else {
            this.$router.push('/specific-donations');
          }
          this.buttonLoading = false;
        })
        .catch(error => {
          this.displayError();
          throw error;
        });
    },
    updateDonationsQueryAfterUpdate(cache, updateSpecificDonation) {
      const testatorId = this.testatorId;

      const query = {
        query: TESTATOR_QUERY,
        variables: { id: testatorId },
      };
      const data = cache.readQuery(query);

      var specificDonation = data.testator.specificDonations.find(
        sd => sd.id == updateSpecificDonation.id
      );
      specificDonation = updateSpecificDonation;

      cache.writeQuery({ ...query, data: data });
    },
    updateAssetsQueryAfterUpdate(cache, updateSpecificDonation) {
      const testatorId = this.testatorId;
      const prevSpecificDonation = this.specificDonation;

      const query = {
        query: TESTATOR_QUERY,
        variables: { id: testatorId },
      };
      const data = cache.readQuery(query);

      // Update previous asset to now be unassigned
      const prevAssetPropertyName =
        this.$options.assetPropertyNames[prevSpecificDonation.assetType];
      var prevAsset = data.testator[prevAssetPropertyName].find(
        a => a.id == prevSpecificDonation.assetId
      );
      prevAsset.specificDonation = null;

      // Update updated asset to be assigned
      const assetPropertyName =
        this.$options.assetPropertyNames[updateSpecificDonation.assetType];
      var asset = data.testator[assetPropertyName].find(
        a => a.id == updateSpecificDonation.assetId
      );
      asset.specificDonation = updateSpecificDonation;

      cache.writeQuery({ ...query, data: data });
    },
  },
  assetPropertyNames: {
    Property: 'properties',
    Vehicle: 'vehicles',
    OtherAsset: 'otherAssets',
    FinancialAsset: 'financialAssets',
  },
};
